import React, { useEffect, useState } from "react";
import styles from './LandingPage.module.css';

const FAQ = (props) => {

    const [activeIndex, setActiveIndex] = useState(0);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "How do I start earning as a creator?",
            answer:
                "To start earning, add your bank account, upload a valid government ID, complete account verification, and choose your monetization model (Subscription or Ad Revenue). Earnings begin once your account is approved."
        },
        {
            question: "What is the difference between a Free account and a Paid subscription account?",
            answer:
                "Paid accounts require fans to subscribe monthly to view content and creators earn 80% revenue. Free accounts allow anyone to follow content and creators earn from ads with a 60% revenue share."
        },
        {
            question: "When will I receive my creator payouts?",
            answer:
                "Earnings become available on a 7-day rolling basis. Withdrawals can be requested once your balance reaches $10, and funds usually arrive within 3–5 business days."
        },
        {
            question: "Can users cancel their subscription anytime?",
            answer:
                "Yes. Users can cancel subscriptions anytime from their Following page. Access continues until the current subscription period ends, but future billing stops."
        },
        {
            question: "Who can see my profile and content?",
            answer:
                "Your profile name, username, avatar, and subscriber count are publicly visible. Content visibility depends on your monetization model and whether users are subscribed to you."
        }
    ];

    return (
        <section className={styles.faq}>
            <div className={styles.landingContainer}>

                <h2>
                    GOT QUESTIONS? <br />
                    <span className={styles.colorText}>
                        WE'VE GOT ANSWERS
                    </span>
                </h2>

                <div className={styles.faqAccordion}>

                    {faqs.map((faq, index) => (

                        <div
                            key={index}
                            className={`${styles.faqItem} ${activeIndex === index
                                ? styles.active
                                : ""
                                }`}
                        >

                            <div
                                className={styles.faqQuestion}
                                onClick={() => toggleFAQ(index)}
                            >
                                {faq.question}

                                <span className={styles.faqIcon}>
                                    +
                                </span>
                            </div>

                            <div className={styles.faqAnswer}>
                                {faq.answer}
                            </div>

                        </div>

                    ))}

                </div>

            </div>
        </section>
    );
};

export default FAQ;